// src/components/DynamicFields.js
import React from "react";
import {
  Grid,
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";

const DynamicFields = ({
  mergedFields,
  formData,
  setFormData,
  raiseTicket,
}) => {

    // Just update state while typing
    const handleDynamicChange = (key, value) => {
      setFormData((prev) => ({
        ...prev,
        dynamicFields: {
          ...prev.dynamicFields,
          [key]: value,
        },
      }));
    };
  
    // Save only when user leaves the field
    const handleDynamicBlur = (key) => {
      raiseTicket({
        ...formData,
        dynamicFields: {
          ...formData.dynamicFields,
          [key]: formData.dynamicFields[key],
        },
      });
    };

  return (
    <Grid container spacing={1}>
      {mergedFields.map((field, idx) => (
        <Grid item xs={3} key={idx}>
          {/* Field Label */}
          <Typography
            component="div"
            variant="body2"
            color="black"
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
              mb: 0.5, // small space below label
            }}
          >
            {field.label}
          </Typography>

          {/* Render Input or Select */}
          {field.type === "input" ? (
            <TextField
              fullWidth
              variant="standard"
              value={field.value || ""}
              onChange={(e) => handleDynamicChange(field.label, e.target.value)}
              onBlur={() => handleDynamicBlur(field.label)}
            />
          ) : field.type === "select" ? (
            <FormControl variant="standard" fullWidth>
              <Select
                value={field.value || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  handleDynamicChange(field.label, value);
                  raiseTicket({
                    ...formData,
                    dynamicFields: {
                      ...formData.dynamicFields,
                      [field.label]: value,
                    },
                  });
                }}
              >
                <MenuItem value="">
                  <em> </em>
                </MenuItem>
                {field.options &&
                  field.options.map((opt, i) => (
                    <MenuItem key={i} value={opt}>
                      {opt}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          ) : null}
        </Grid>
      ))}
    </Grid>
  );
};

export default DynamicFields;
